module.exports = __webpack_public_path__ + "img/light.ea09aa4e.svg";